import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges, SimpleChange } from '@angular/core';

@Component({
  selector: 'sk-time-selector',
  templateUrl: './time-selector.component.html',
  styleUrls: ['./time-selector.component.scss']
})
export class TimeSelectorComponent implements OnInit, OnChanges {
  @Output() timeSelect = new EventEmitter();
  @Input() dateInput: any;
  timeSelected: any;
  hour = '';
  min = '';
  tDay = '';
  constructor() { }

  private setTime(strTime: string) {
    if (strTime) {
      const hourMin = strTime.split(':');
      const minTDay = hourMin[1].split(' ');
      this.hour = parseInt(hourMin[0], 10).toString();
      this.min = minTDay[0].toString();
      this.tDay = minTDay[1].toString();
    }
  }

  ngOnInit() {
    this.setTime(this.dateInput);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.dateInput) {
      this.setTime((changes.dateInput as SimpleChange).currentValue);
    }
  }

  selectHour(hour: string) {
    this.timeSelected = '';
    this.hour = hour;
    if (parseInt(hour, 10) < 10 ) {
      hour = '0' + hour;
    }
    this.emitData();
  }

  selectMinute(min: string) {
    this.min = min;
    this.emitData();
  }

  selectTimeDay(timeDay: string) {
    this.tDay = timeDay;
    this.emitData();
  }

  emitData() {
    this.timeSelect.emit(this.hour + ':' + this.min + ' ' + this.tDay);
  }

}
